import {createRoot, hydrateRoot} from 'react-dom/client';
import ComparisonTools from '../pages/ComparisonTools/ComparisonTools'
import "../index.css";
import "../pages/ComparisonTools/ComparisonTools.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<ComparisonTools {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <ComparisonTools {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).ComparisonToolsVC = {mount, hydrate, unmount}